import { post } from "./base";
import store from "../store";
import history from "../router/history";
import { loginEnd, loginStart, loginEndFailed } from "../store/actions/auth";
import { guide, signIn } from "../router/routes";

import url from "./url";
import queries from "./queries";

const { dispatch } = store;

export default class authAPI {
  static async login({ data } = {}) {
    try {
      dispatch(loginStart());
      const editedData = {
        /* django username is case-sensitive by default */
        username: data.username.toLowerCase(),
        password: data.password
      };
      /* await request here */
      const query = url(queries.auth);
      const response = await post(query, editedData);
      const { token } = response;
      localStorage.setItem("token", token);
      /* dispatch for changing auth status here */
      dispatch(loginEnd());
      /* dispatch redirect here */
      history.push(guide);
      return response;
    } catch (error) {
      const err = (error.response && error.response.data) || error;
      return dispatch(loginEndFailed(err));
    }
  }

  static async logOut() {
    localStorage.setItem("token", "");
    history.push(signIn);
  }
}
